module.exports = __webpack_public_path__ + "static/bg_banner-home-201eefb23850de1e6d1f9c10abbf0aed.jpg";